var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipe1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210px",
    height: "210px",
    viewBox: "55 50 7 90",
    id: "svg9840",
    inkscape: "http://www.inkscape.org/namespaces/inkscape",
    sodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9837"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g11742"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#074e9c",
      strokeWidth: 1.20091,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6274-4",
    cx: 58.186298,
    cy: 104.59254,
    r: 25.317205
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#074e9c",
      strokeWidth: 0.757475,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "circle6534-0",
    cx: -47.382877,
    cy: 109.90956,
    transform: "matrix(-0.99493955,0.10047534,0.10047534,0.99493955,0,0)",
    r: 23.621166
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#074e9c",
      strokeWidth: 1.19,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "circle6739-9",
    cx: 58.186298,
    cy: 104.59254,
    r: 16.561441
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u041C\\u0423\\u0417    \"\\u0413 \\u043E \\u0440 \\u043E \\u0434 \\u0441 \\u043A \\u0430 \\u044F    \\u043F \\u043E \\u043B \\u0438 \\u043A \\u043B \\u0438 \\u043D \\u0438 \\u043A \\u0430 \\u2116   \"",
    id: "text32888",
    style: {
      fontSize: "4.58611px",
      lineHeight: 1.25,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "Roboto",
      fill: "#074e9c",
      strokeWidth: 0.264583
    },
    transform: "translate(-75.650906,-52.958508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 124.44946,176.6531 0.37328,-2.64397 -2.02188,1.74289 -0.64255,-0.35119 1.56372,-2.86098 0.49518,0.27064 -0.51552,0.94318 -0.73862,1.23466 2.04994,-1.74288 0.35566,0.1944 -0.36097,2.66346 0.6393,-1.28639 0.51552,-0.94318 0.49517,0.27064 -1.56372,2.86098 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.2946,172.56467 -1.59137,0.89393 -0.48426,-0.40181 2.60106,-1.35682 0.20939,-0.091 q 0.42686,-0.16376 0.81289,0.15653 l 0.17064,0.15905 -0.28943,0.34181 q -0.0356,-0.0412 -0.14076,-0.12843 -0.18612,-0.15443 -0.3935,-0.0588 l -0.26549,0.13761 -0.65748,2.53883 -0.47564,-0.39465 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.14607,170.56446 q -0.16499,0.1447 -0.15338,0.35492 0.0116,0.21022 0.19914,0.42403 0.16094,0.18351 0.36637,0.22077 0.20375,0.0387 0.35696,-0.0956 l 0.37208,0.42426 q -0.20034,0.1757 -0.45436,0.2019 -0.25403,0.0262 -0.51264,-0.0955 -0.2603,-0.12019 -0.46849,-0.35758 -0.36913,-0.42089 -0.38939,-0.81416 -0.0217,-0.39496 0.30825,-0.68436 0.16668,-0.14617 0.395,-0.16771 0.22833,-0.0215 0.46861,0.0894 -0.10943,-0.26741 -0.0591,-0.50214 0.0471,-0.23493 0.26094,-0.42245 0.32998,-0.2894 0.74675,-0.20814 0.41509,0.0827 0.78422,0.50362 0.22739,0.25927 0.31936,0.55092 0.0905,0.28997 0.0236,0.53631 -0.0684,0.24465 -0.27547,0.42626 l -0.37208,-0.42425 q 0.15825,-0.1388 0.15251,-0.36609 -0.007,-0.22582 -0.1846,-0.42784 -0.19786,-0.2256 -0.42352,-0.26895 -0.22714,-0.045 -0.39718,0.1041 -0.20708,0.18161 -0.19336,0.38404 0.0105,0.20222 0.21431,0.43455 l 0.25249,0.28789 -0.33671,0.2953 -0.2392,-0.27273 q -0.39571,-0.4512 -0.76104,-0.13079 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.01785,164.89261 0.84118,-0.22266 0.10642,0.29251 -1.10267,0.4012 -0.13323,-0.36616 z m -0.23047,-0.63341 0.84118,-0.22266 0.10643,0.29251 -1.10268,0.4012 -0.13322,-0.36615 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.34185,161.31974 0.35361,1.46268 2.72511,-0.65882 0.13261,0.5485 -3.16914,0.76617 -0.48622,-2.01119 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.63904,159.24763 q -0.35589,0.0107 -0.6444,-0.12177 -0.29074,-0.1324 -0.45061,-0.383 -0.16211,-0.25052 -0.17207,-0.58179 -0.0147,-0.49019 0.29172,-0.80408 0.30639,-0.31613 0.82717,-0.35643 l 0.12752,-0.006 q 0.35812,-0.0108 0.64432,0.11953 0.28613,0.12806 0.44831,0.38083 0.16211,0.25052 0.1722,0.58627 0.0154,0.51257 -0.31553,0.83168 -0.33325,0.31694 -0.90177,0.33402 z m 0.0307,-0.54532 q 0.3738,-0.0112 0.5818,-0.17207 0.20576,-0.16076 0.19748,-0.43607 -0.008,-0.27531 -0.22772,-0.42106 -0.21952,-0.14799 -0.63361,-0.13554 -0.36708,0.011 -0.57718,0.17641 -0.21017,0.16314 -0.20203,0.43397 0.008,0.26636 0.22535,0.41665 0.21511,0.15036 0.63591,0.13771 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.14592,153.05791 q 0.55308,0.1001 0.83814,0.41112 0.28286,0.31062 0.20629,0.73369 -0.071,0.39223 -0.37147,0.58135 l 1.1304,0.20458 -0.0969,0.53546 -3.30086,-0.59741 0.0893,-0.49359 0.24638,0.0218 q -0.24379,-0.28762 -0.17041,-0.69307 0.079,-0.43629 0.44975,-0.62406 0.36899,-0.19037 0.94631,-0.0859 z m -0.14279,0.52487 q -0.35696,-0.0646 -0.59222,0.0407 -0.23486,0.10313 -0.28272,0.36756 -0.0594,0.32832 0.18569,0.5206 l 1.05769,0.19143 q 0.30396,-0.0952 0.36378,-0.42571 0.0463,-0.25561 -0.13274,-0.43593 -0.18081,-0.18292 -0.59948,-0.25869 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.59012,151.35882 q -0.32988,-0.13399 -0.54028,-0.37172 -0.21246,-0.23858 -0.25747,-0.53239 -0.0471,-0.29467 0.0776,-0.60172 0.18455,-0.45436 0.59169,-0.61769 0.40799,-0.16541 0.90066,0.008 l 0.1191,0.046 q 0.33195,0.13484 0.54111,0.36965 0.21001,0.23274 0.25625,0.52947 0.0471,0.29467 -0.0793,0.60587 -0.19298,0.4751 -0.62463,0.63332 -0.43288,0.15529 -0.95985,-0.0588 z m 0.24834,-0.48645 q 0.34648,0.14073 0.60172,0.0776 0.25317,-0.0639 0.35682,-0.31913 0.10366,-0.25518 -0.0382,-0.47716 -0.14102,-0.22406 -0.52484,-0.37996 -0.34025,-0.13821 -0.59925,-0.0718 -0.25816,0.0643 -0.36013,0.31537 -0.10028,0.24689 0.0378,0.47217 0.13603,0.22445 0.52607,0.38288 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.98543,148.06368 q -0.0812,-0.32953 -0.22494,-0.52004 -0.1443,-0.19362 -0.42751,-0.40627 l -0.74757,-0.54917 0.94925,-1.3882 1.64145,1.12242 0.1896,-0.27727 0.95381,0.65222 -0.30589,0.44733 -0.59521,-0.40701 -0.87721,1.28284 0.59521,0.40701 -0.31094,0.45472 -0.95255,-0.65406 z m 0.36024,-0.52681 0.52455,-0.76712 -1.25511,-0.85825 -0.34507,0.50463 0.37379,0.27459 q 0.53314,0.40255 0.70184,0.84615 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.20355,144.17882 q 0.14763,-0.14046 0.16317,-0.31906 0.0155,-0.17859 -0.0984,-0.31131 l 0.37152,-0.35347 q 0.14941,0.17004 0.18952,0.40387 0.0386,0.23222 -0.0466,0.47085 -0.0851,0.23864 -0.27496,0.41923 -0.36827,0.35038 -0.81094,0.31718 -0.44268,-0.0332 -0.84245,-0.4534 l -0.0386,-0.0406 q -0.38125,-0.40073 -0.39554,-0.84458 -0.0158,-0.44548 0.35407,-0.7974 0.31312,-0.2979 0.68384,-0.30133 0.37081,-0.007 0.663,0.28103 l -0.37152,0.35346 q -0.15004,-0.1447 -0.33999,-0.14944 -0.18833,-0.006 -0.33759,0.13573 -0.19144,0.18214 -0.16253,0.42044 0.0274,0.23669 0.29432,0.52053 l 0.0602,0.0633 q 0.27165,0.28554 0.50815,0.32944 0.23657,0.0407 0.43126,-0.14448 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 123.6487,141.55822 -0.23342,0.14622 0.50879,0.81223 -0.46115,0.28886 -1.28623,-2.05334 0.46115,-0.28887 0.51354,0.81982 0.20306,-0.1272 0.0539,-1.17525 0.56932,-0.35663 -0.12624,1.44783 1.47509,0.56629 -0.59968,0.37565 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 127.99211,140.51712 q -0.0579,-0.0525 -0.13793,-0.18989 -0.14843,0.34476 -0.50081,0.4765 -0.3419,0.12782 -0.63087,0.0135 -0.28897,-0.11429 -0.3964,-0.40165 -0.13567,-0.36288 0.0607,-0.65622 0.19765,-0.29623 0.69896,-0.48365 l 0.31253,-0.11684 -0.0557,-0.14892 q -0.0659,-0.17619 -0.20366,-0.24421 -0.13858,-0.0701 -0.33994,0.005 -0.17409,0.0651 -0.25232,0.19474 -0.079,0.12756 -0.0288,0.2618 l -0.5097,0.19056 q -0.0698,-0.18668 -0.006,-0.39446 0.0626,-0.20987 0.23993,-0.38136 0.17945,-0.17228 0.44164,-0.2703 0.39852,-0.14899 0.71082,-0.0362 0.31152,0.11065 0.45348,0.47117 l 0.38267,1.02359 q 0.11449,0.30623 0.26871,0.45657 l 0.0133,0.0357 z m -0.69727,-0.15769 q 0.15102,-0.0565 0.25572,-0.17928 0.1068,-0.1236 0.12765,-0.27245 l -0.15997,-0.42789 -0.27478,0.10273 q -0.28316,0.10586 -0.38894,0.25777 -0.10577,0.15191 -0.0383,0.33229 0.0549,0.14683 0.18431,0.19885 0.13074,0.0491 0.29434,-0.012 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 131.62644,137.22047 0.37515,2.39372 -0.53538,0.0839 -0.13765,-0.87829 -0.50219,0.0787 -0.3734,0.95838 -0.5575,0.0874 0.41262,-1.05519 q -0.23579,-0.0583 -0.3823,-0.21209 -0.14429,-0.15418 -0.17931,-0.37762 -0.0524,-0.33406 0.17099,-0.58666 0.22521,-0.25516 0.66255,-0.32824 z m -1.34029,1.00791 q 0.0236,0.15044 0.1491,0.22823 0.12739,0.0752 0.30216,0.0478 l 0.52874,-0.0829 -0.10817,-0.69024 -0.49556,0.0777 q -0.19689,0.0309 -0.29854,0.14879 -0.10165,0.11793 -0.0777,0.27058 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 139.15456,140.32085 -0.52802,-0.1315 0.47949,-1.92522 -0.91698,-0.22838 -0.47949,1.92522 -0.52802,-0.13151 0.58556,-2.35111 1.97302,0.49139 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.22338,139.7541 q 0.15527,-0.32042 0.40624,-0.51483 0.25195,-0.19642 0.54808,-0.22214 0.29711,-0.0277 0.59536,0.1168 0.44132,0.21385 0.5777,0.63079 0.1384,0.41792 -0.067,0.8982 l -0.0536,0.11585 q -0.15624,0.32243 -0.40422,0.5158 -0.24597,0.19435 -0.54509,0.2211 -0.29711,0.0277 -0.59939,-0.11875 -0.46148,-0.22362 -0.59114,-0.66468 -0.12668,-0.4421 0.12135,-0.95396 z m 0.46919,0.2796 q -0.16307,0.33654 -0.11679,0.59536 0.0472,0.25681 0.29512,0.37691 0.24787,0.12011 0.47865,-0.007 0.23279,-0.12608 0.41344,-0.49889 0.16014,-0.33049 0.11081,-0.59328 -0.0473,-0.26182 -0.29116,-0.37997 -0.23981,-0.1162 -0.47364,0.007 -0.23285,0.12107 -0.41643,0.49992 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.18642,142.05178 -1.48688,1.91306 -0.42964,-0.33393 1.21754,-1.56652 -0.54104,-0.4205 -0.55343,0.63908 q -0.40737,0.45481 -0.72296,0.54703 -0.31244,0.0918 -0.62362,-0.15003 l -0.13261,-0.10307 0.27582,-0.35852 0.0953,0.0599 q 0.15656,0.0905 0.33839,-0.0121 0.18498,-0.10298 0.51735,-0.49413 l 0.67024,-0.78936 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.77186,144.75915 0.34868,0.41484 -1.85479,1.55896 -0.34868,-0.41484 1.23767,-1.04027 -1.84857,0.31344 -0.34868,-0.41484 1.85479,-1.55896 0.34868,0.41484 -1.23767,1.04027 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 150.4822,148.46884 -0.13014,-0.24275 -0.84469,0.45286 -0.25711,-0.47958 2.13541,-1.14483 0.25711,0.47957 -0.85259,0.45709 0.11322,0.21117 1.16894,0.13302 0.31743,0.59207 -1.43602,-0.22359 -0.66448,1.43355 -0.33435,-0.62365 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 153.7236,152.7758 -2.32449,0.68365 -0.15354,-0.52204 1.90342,-0.55981 -0.19334,-0.65739 -0.82256,0.19524 q -0.59635,0.13104 -0.90634,0.0215 -0.30721,-0.10805 -0.41841,-0.48615 l -0.0474,-0.16113 0.43333,-0.12978 0.0423,0.10426 q 0.0742,0.16492 0.28168,0.18792 0.21028,0.0245 0.70856,-0.0987 l 1.00517,-0.24894 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 154.24392,156.47947 0.0413,0.54033 -2.41588,0.18483 -0.0413,-0.54033 1.61207,-0.12334 -1.6845,-0.82337 -0.0413,-0.54033 2.41588,-0.18483 0.0413,0.54034 -1.61207,0.12333 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.54598,160.96313 0.0731,-0.53923 0.96972,0.13138 0.12657,-0.93422 -0.96972,-0.13138 0.073,-0.53922 2.401,0.32529 -0.073,0.53923 -1.00079,-0.13559 -0.12657,0.93421 1.00079,0.13559 -0.0731,0.53923 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.90776,164.88095 -0.1829,0.51011 -2.28077,-0.81775 0.1829,-0.51011 1.52192,0.54567 -1.20147,-1.43943 0.1829,-0.51012 2.28077,0.81775 -0.1829,0.51012 -1.52192,-0.54567 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 150.0647,167.36361 0.14388,-0.23487 -0.81727,-0.50064 0.28424,-0.46402 2.0661,1.26565 -0.28425,0.46401 -0.82491,-0.50532 -0.12516,0.20432 0.47517,1.07626 -0.35092,0.57286 -0.53177,-1.35254 -1.57293,0.14991 0.36963,-0.60341 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 146.63589,170.227 q 0.0751,0.0214 0.20782,0.10908 -0.0198,-0.37484 0.23769,-0.64913 0.24981,-0.26613 0.55951,-0.29177 0.30969,-0.0256 0.53337,0.18432 0.28246,0.26513 0.2365,0.61512 -0.0459,0.35315 -0.41214,0.74336 l -0.22836,0.24328 0.11592,0.10881 q 0.13715,0.12874 0.29082,0.12863 0.1553,0.001 0.30242,-0.15532 0.12721,-0.13551 0.13986,-0.28641 0.0143,-0.14937 -0.0902,-0.24746 l 0.37242,-0.39675 q 0.14531,0.1364 0.18061,0.35074 0.0369,0.21587 -0.046,0.44821 -0.0845,0.23397 -0.27605,0.43806 -0.29119,0.31021 -0.62111,0.34758 -0.32829,0.0389 -0.61535,-0.22134 l -0.79676,-0.74789 q -0.23837,-0.22376 -0.44325,-0.29015 l -0.0278,-0.0261 z m 0.69492,-0.16773 q -0.11034,0.11756 -0.14975,0.27406 -0.0409,0.15813 0.006,0.3008 l 0.33307,0.31264 0.20077,-0.21388 q 0.20689,-0.22042 0.23437,-0.40347 0.0275,-0.18306 -0.11293,-0.31486 -0.11429,-0.10728 -0.25337,-0.0965 -0.13897,0.0139 -0.25851,0.14125 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.0976,174.69556 1.15982,-0.71737 0.17551,0.28377 -1.15981,0.71737 z m 2.07189,0.58269 q 0.18729,0.30281 0.11945,0.59755 -0.0667,0.29663 -0.36376,0.48039 -0.2971,0.18376 -0.5911,0.11284 -0.29591,-0.0697 -0.49145,-0.38589 l -0.0919,-0.14855 q -0.18376,-0.29709 -0.12091,-0.59137 0.0629,-0.29428 0.36567,-0.48158 0.30281,-0.18729 0.59799,-0.11446 0.29328,0.074 0.48411,0.38253 z m -0.43223,0.0462 q -0.11308,-0.18283 -0.2643,-0.23148 -0.15121,-0.0487 -0.30547,0.0468 -0.15046,0.0931 -0.17255,0.24891 -0.024,0.15703 0.0926,0.34557 l 0.0954,0.15426 q 0.1119,0.18092 0.26312,0.22958 0.15239,0.0506 0.30474,-0.0437 0.15046,-0.0931 0.17327,-0.25199 0.024,-0.15702 -0.0914,-0.34366 z m -0.62426,-2.34172 0.5104,-0.31569 2.16832,1.38142 -1.218,-1.96921 0.46469,-0.28742 1.71509,2.77289 -0.50849,0.31451 -2.17757,-1.38359 1.22153,1.97492 -0.46088,0.28507 z",
    style: {
      fontWeight: 500,
      InkscapeFontSpecification: "'Roboto Medium'"
    },
    id: "path103639"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 138.01314,178.27387 -0.0889,-0.79956 0.24389,-0.048 0.21137,1.08585 -0.30761,0.0605 z m -0.59324,0.11673 -0.0889,-0.79956 0.24389,-0.048 0.21137,1.08584 -0.30761,0.0605 z",
    id: "path103641"
  }))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u0414\\u043B\\u044F \\u0440\\u0435\\u0446\\u0435\\u043F\\u0442\\u043E\\u0432",
    transform: "scale(0.98530594,1.0149132)",
    id: "text230184-8",
    style: {
      fontSize: "6.21297px",
      lineHeight: 1.25,
      fill: "#074e9c",
      strokeWidth: 0.258874
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 56.827227,95.737238 v 3.418954 h 0.55213 v 1.337848 q 0,0.10011 -0.06977,0.16079 -0.06977,0.0637 -0.178987,0.0637 h -0.482354 v -0.952579 h -2.530087 v 0.728079 q 0,0.10011 -0.06977,0.16079 -0.06977,0.0637 -0.182021,0.0637 h -0.479321 v -1.562348 h 0.397412 q 0.06674,-0.04247 0.133482,-0.133482 0.06674,-0.09101 0.130448,-0.254829 0.06371,-0.166852 0.121347,-0.418647 0.05764,-0.254829 0.103145,-0.61887 0.04854,-0.367075 0.08191,-0.858531 0.0364,-0.491455 0.05157,-1.134595 z m -1.671555,0.609769 q -0.03034,0.573365 -0.08191,1.022349 -0.05157,0.445951 -0.121347,0.788756 -0.06674,0.339772 -0.151684,0.5855 -0.08494,0.242694 -0.178986,0.41258 h 1.404592 v -2.809185 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 60.446404,96.75352 v 3.012441 H 59.67585 v -2.426942 h -0.549096 q -0.03337,0.549096 -0.103145,0.946507 -0.06674,0.397412 -0.160784,0.673477 -0.09101,0.273031 -0.209324,0.439883 -0.11528,0.166852 -0.245728,0.257862 -0.127414,0.09101 -0.269997,0.121347 -0.139549,0.03034 -0.282132,0.03034 -0.17292,0 -0.248762,-0.03034 -0.07281,-0.0273 -0.07281,-0.08191 v -0.473253 h 0.166852 q 0.08494,0 0.166853,-0.0273 0.08494,-0.03034 0.163818,-0.118313 0.07888,-0.09101 0.14865,-0.254829 0.07281,-0.166852 0.130448,-0.439883 0.06067,-0.276064 0.103145,-0.673476 0.04551,-0.400445 0.07281,-0.955608 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.489182,99.765961 h -0.731116 v -1.195269 h -0.103145 q -0.08798,0 -0.145617,0.0182 -0.05764,0.01517 -0.09708,0.04551 -0.03944,0.03034 -0.06977,0.06977 -0.0273,0.03944 -0.05764,0.08798 l -0.436849,0.712915 q -0.03944,0.06371 -0.08191,0.112246 -0.04247,0.04854 -0.100112,0.08191 -0.05461,0.03337 -0.127414,0.05157 -0.07281,0.01517 -0.175953,0.01517 h -0.530894 l 0.718981,-1.05572 q 0.145617,-0.209323 0.367075,-0.288199 -0.209323,-0.03944 -0.35494,-0.121347 -0.142583,-0.08191 -0.233593,-0.188088 -0.09101,-0.109212 -0.130448,-0.23056 -0.03944,-0.12438 -0.03944,-0.242694 0,-0.166852 0.06674,-0.324603 0.06674,-0.160785 0.212357,-0.285166 0.145617,-0.12438 0.373143,-0.200222 0.230559,-0.07584 0.555162,-0.07584 h 1.122461 z m -1.556276,-2.093237 q 0,0.200222 0.130448,0.312468 0.130448,0.112247 0.348873,0.112247 h 0.345839 v -0.846396 h -0.367075 q -0.130448,0 -0.218425,0.03944 -0.08798,0.0364 -0.142583,0.09708 -0.05157,0.06067 -0.07584,0.136516 -0.02123,0.07584 -0.02123,0.14865 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.405031,107.59285 z m 0,0.97684 v -3.98928 h 0.473254 q 0.07281,0 0.121347,0.0334 0.05157,0.0334 0.06674,0.10314 l 0.06371,0.26393 q 0.09101,-0.10011 0.191122,-0.18505 0.100111,-0.085 0.215391,-0.14562 0.118313,-0.0607 0.251795,-0.094 0.136515,-0.0334 0.294267,-0.0334 0.23966,0 0.439883,0.10314 0.200222,0.10315 0.345839,0.30033 0.145616,0.19416 0.224492,0.48236 0.08191,0.2882 0.08191,0.65527 0,0.33674 -0.09101,0.62494 -0.09101,0.2882 -0.257863,0.50056 -0.166852,0.20932 -0.403479,0.33067 -0.233593,0.11831 -0.524826,0.11831 -0.245728,0 -0.415613,-0.0728 -0.169886,-0.0758 -0.306402,-0.20325 v 1.2074 z m 1.413694,-3.43716 q -0.215391,0 -0.364042,0.088 -0.14865,0.0849 -0.279098,0.24876 v 1.33482 q 0.11528,0.13955 0.248762,0.19719 0.136515,0.0546 0.291233,0.0546 0.14865,0 0.269997,-0.0576 0.124381,-0.0607 0.212357,-0.18202 0.08798,-0.12135 0.133482,-0.30641 0.04854,-0.18808 0.04854,-0.44595 0,-0.25483 -0.03944,-0.43078 -0.03944,-0.17899 -0.112246,-0.2882 -0.07281,-0.11224 -0.175953,-0.16078 -0.103145,-0.0516 -0.233593,-0.0516 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 49.557021,107.59285 z m 1.44403,-3.06098 q 0.285166,0 0.524826,0.094 0.239661,0.091 0.41258,0.26696 0.17292,0.17292 0.269998,0.42775 0.09708,0.25483 0.09708,0.58247 0,0.088 -0.0091,0.14562 -0.0091,0.0546 -0.03034,0.088 -0.0182,0.0334 -0.05461,0.0485 -0.03337,0.0121 -0.08494,0.0121 h -1.802003 q 0.0182,0.21842 0.07887,0.3792 0.06067,0.16079 0.160785,0.26393 0.100111,0.10315 0.236627,0.15472 0.136515,0.0485 0.303367,0.0485 0.166853,0 0.2882,-0.0394 0.12438,-0.0425 0.215391,-0.088 0.09404,-0.0485 0.166852,-0.088 0.07281,-0.0425 0.142583,-0.0425 0.08494,0 0.139549,0.0698 l 0.221458,0.28517 q -0.12438,0.14562 -0.276064,0.24269 -0.151684,0.094 -0.315503,0.15169 -0.160785,0.0546 -0.327637,0.0789 -0.166852,0.0243 -0.321569,0.0243 -0.312469,0 -0.582466,-0.10314 -0.269998,-0.10315 -0.47022,-0.3064 -0.200223,-0.20629 -0.315503,-0.50663 -0.112246,-0.30337 -0.112246,-0.70078 0,-0.3064 0.100112,-0.5764 0.100111,-0.27303 0.285165,-0.47325 0.188088,-0.20326 0.455052,-0.32157 0.266963,-0.11831 0.603701,-0.11831 z m 0.01517,0.54909 q -0.294267,0 -0.461119,0.17292 -0.166852,0.16989 -0.215391,0.48236 h 1.274144 q 0,-0.13045 -0.0364,-0.24877 -0.03337,-0.11831 -0.109212,-0.20932 -0.07281,-0.091 -0.185055,-0.14258 -0.112246,-0.0546 -0.266963,-0.0546 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 52.845527,104.58041 h 0.770553 v 2.44514 h 1.007181 v -2.44514 h 0.770554 v 2.44514 h 0.524826 v 1.34088 q 0,0.10618 -0.06067,0.16686 -0.05764,0.0607 -0.154717,0.0607 h -0.482355 v -1.00111 h -2.375368 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 56.124931,107.59285 z m 1.44403,-3.06098 q 0.285166,0 0.524826,0.094 0.239661,0.091 0.41258,0.26696 0.17292,0.17292 0.269997,0.42775 0.09708,0.25483 0.09708,0.58247 0,0.088 -0.0091,0.14562 -0.0091,0.0546 -0.03034,0.088 -0.0182,0.0334 -0.05461,0.0485 -0.03337,0.0121 -0.08494,0.0121 h -1.802004 q 0.0182,0.21842 0.07888,0.3792 0.06067,0.16079 0.160785,0.26393 0.100111,0.10315 0.236626,0.15472 0.136516,0.0485 0.303368,0.0485 0.166852,0 0.288199,-0.0394 0.124381,-0.0425 0.215391,-0.088 0.09404,-0.0485 0.166853,-0.088 0.07281,-0.0425 0.142582,-0.0425 0.08494,0 0.13955,0.0698 l 0.221458,0.28517 q -0.124381,0.14562 -0.276065,0.24269 -0.151683,0.094 -0.315502,0.15169 -0.160785,0.0546 -0.327637,0.0789 -0.166852,0.0243 -0.32157,0.0243 -0.312468,0 -0.582466,-0.10314 -0.269997,-0.10315 -0.47022,-0.3064 -0.200222,-0.20629 -0.315502,-0.50663 -0.112246,-0.30337 -0.112246,-0.70078 0,-0.3064 0.100111,-0.5764 0.100112,-0.27303 0.285166,-0.47325 0.188088,-0.20326 0.455051,-0.32157 0.266964,-0.11831 0.603702,-0.11831 z m 0.01517,0.54909 q -0.294267,0 -0.461119,0.17292 -0.166853,0.16989 -0.215391,0.48236 h 1.274144 q 0,-0.13045 -0.0364,-0.24877 -0.03337,-0.11831 -0.109213,-0.20932 -0.07281,-0.091 -0.185054,-0.14258 -0.112246,-0.0546 -0.266963,-0.0546 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 62.016331,104.58041 v 3.01244 h -0.770554 v -2.44515 h -1.049652 v 2.44515 h -0.770554 v -3.01244 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 62.41071,104.58041 h 2.3602 v 0.56729 h -0.794823 v 2.44515 H 63.205533 V 105.1477 H 62.41071 Z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 64.937762,107.59285 z m 1.486501,-3.06098 q 0.330671,0 0.603702,0.10921 0.273031,0.10618 0.467186,0.30943 0.194156,0.20023 0.300334,0.48843 0.106179,0.28516 0.106179,0.6401 0,0.36101 -0.106179,0.64921 -0.106178,0.2882 -0.300334,0.49145 -0.194155,0.20023 -0.467186,0.30944 -0.273031,0.10921 -0.603702,0.10921 -0.333704,0 -0.609769,-0.10921 -0.27303,-0.10921 -0.470219,-0.30944 -0.194156,-0.20325 -0.300334,-0.49145 -0.106179,-0.2882 -0.106179,-0.64921 0,-0.35494 0.106179,-0.6401 0.106178,-0.2882 0.300334,-0.48843 0.197189,-0.20325 0.470219,-0.30943 0.276065,-0.10921 0.609769,-0.10921 z m 0,2.51795 q 0.348873,0 0.515726,-0.2427 0.166852,-0.24572 0.166852,-0.72201 0,-0.47629 -0.166852,-0.71898 -0.166853,-0.24573 -0.515726,-0.24573 -0.35494,0 -0.524826,0.24573 -0.166852,0.24269 -0.166852,0.71898 0,0.47629 0.166852,0.72201 0.169886,0.2427 0.524826,0.2427 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.478063,104.58041 h 1.219538 q 0.291233,0 0.50359,0.0576 0.212358,0.0546 0.348873,0.15168 0.139549,0.0971 0.20629,0.23056 0.06674,0.13348 0.06674,0.29123 0,0.0971 -0.0273,0.20326 -0.02427,0.10618 -0.08798,0.20325 -0.06371,0.094 -0.175953,0.17292 -0.109212,0.0759 -0.282132,0.12135 0.151684,0.0303 0.276065,0.088 0.127414,0.0576 0.215391,0.14258 0.09101,0.0849 0.139549,0.20022 0.05157,0.11528 0.05157,0.2609 0,0.23359 -0.100111,0.40348 -0.09708,0.16685 -0.260896,0.27606 -0.163819,0.10618 -0.37921,0.15775 -0.215391,0.0516 -0.44595,0.0516 h -1.268077 z m 0.731116,1.72616 v 0.76145 h 0.533927 q 0.221458,0 0.348873,-0.10314 0.130448,-0.10618 0.130448,-0.2882 0,-0.0759 -0.02124,-0.14259 -0.02123,-0.0698 -0.07584,-0.11831 -0.05461,-0.0516 -0.14865,-0.0789 -0.09101,-0.0303 -0.233593,-0.0303 z m 0,-0.47629 h 0.467186 q 0.103145,0 0.191122,-0.0273 0.08798,-0.0303 0.14865,-0.0819 0.06371,-0.0546 0.09708,-0.12742 0.0364,-0.0758 0.0364,-0.16685 0,-0.0637 -0.02427,-0.12741 -0.02427,-0.0637 -0.07887,-0.11225 -0.05461,-0.0485 -0.145617,-0.0789 -0.09101,-0.0303 -0.224492,-0.0303 h -0.467186 z",
    style: {
      fontWeight: "bold",
      fontFamily: "Carlito",
      InkscapeFontSpecification: "'Carlito Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path11679"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipe1);
export default __webpack_public_path__ + "static/media/Recipe1.d721d483d20fd27b41c770a12b08babf.svg";
export { ForwardRef as ReactComponent };